import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

export const NAME = 'search'

const resultsIsLoading = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return true
    case ActionTypes.FETCH_FAILURE:
    case ActionTypes.FETCH_SUCCESS:
      return false
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS: {
      let byId = {}
      action.results.forEach((e, i) => (byId[i] = { id: i, ...e }))
      return byId
    }
    case ActionTypes.HOVER_RESULT_START:
      if (!action.closureId) return state
      return {
        ...state,
        [action.closureId]: {
          ...state[action.closureId],
          roadSegments: state[action.closureId].roadSegments.map((segment) => {
            segment.hover = segment.hover || segment.id === action.segmentId
            return segment
          }),
        },
      }
    case ActionTypes.HOVER_RESULT_END:
      if (!action.closureId) return state
      return {
        ...state,
        [action.closureId]: {
          ...state[action.closureId],
          roadSegments: state[action.closureId].roadSegments.map((segment) => {
            segment.hover = segment.hover && segment.id !== action.segmentId
            return segment
          }),
        },
      }
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return action.results.map((e, i) => i)
    default:
      return state
  }
}

const initialSelected = { resultIds: [], current: 0 }
const selected = (state = initialSelected, action) => {
  switch (action.type) {
    case ActionTypes.SELECT_RESULTS:
      return {
        resultIds: action.resultIds,
        current: 0,
      }
    case ActionTypes.CLEAR_SELECTION:
      return initialSelected
    default:
      return state
  }
}

const search = combineReducers({
  byId,
  allKeys,
  resultsIsLoading,
  selected,
})

export default search
